import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { useFetch } from '@/hooks/useFetch';
import { PageHeader } from '@/components/kit';
import { BackLink, recordGate } from '@/components/record';
import OrderForm, { orderToForm } from '@/components/admin/OrderForm';
import { ORDER_FIELDS } from '@/shared/fields';
import { committed, logActivity } from '@/shared/data';

export const route = { path: '/admin/orders/:id/edit', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function EditOrder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { data: order, loading, error, run } = useFetch(
    () => sdk.table('orders_c').select(ORDER_FIELDS).get(id).then((r) => r.data ?? null),
    [id],
  );

  const back = <BackLink to={`/admin/orders/${id}`} label="Back to Order" />;
  const gate = recordGate({ back, loading, record: order, error, run, what: 'Order' });
  if (gate) return gate;

  async function save(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('orders_c').update({ Id: order.Id, ...payload });
      if (!committed(res, 'Order saved')) return;
      logActivity('Order', `Edited ${payload.Name}`, payload.Name, payload.status_c ?? '');
      navigate(`/admin/orders/${order.Id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-6xl">
      {back}
      <PageHeader eyebrow="Edit order" title={order.Name} description="Every field on the order. Dates are shown in your local time." />
      <OrderForm
        key={order.Id}
        initial={orderToForm(order)}
        onSubmit={save}
        saving={saving}
        submitLabel="Save changes"
        cancelTo={`/admin/orders/${order.Id}`}
      />
    </div>
  );
}
